import { Ref } from "react";

import HistoryRounded from "@mui/icons-material/HistoryRounded";
import { Box, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

import { LastOpenedClientResponse } from "@/api";
import { useLanguageContext } from "@/common/contexts/language-context/LanguageContext";
import { formatClientDisplayName } from "@/common/helper/clientNameHelper";
import { useTranslation } from "@/translations";

import { formatClientSmartSearchDate } from "./ClientListItem.utils";

interface Props {
  client: LastOpenedClientResponse;
  onClick: () => void;
  highlighted: boolean;
  id: string;
  ariaSelected: boolean;
  ref: Ref<HTMLLIElement>;
}

export const ClientListItem = ({ client, highlighted, onClick, id, ariaSelected, ref }: Props) => {
  const { language } = useLanguageContext();
  const { t } = useTranslation();

  return (
    <ListItemButton
      component="li"
      ref={ref}
      id={id}
      role={"option"}
      aria-selected={ariaSelected}
      /**
       * Must use onMouseDown to fires before onBlur on the Search Field
       * Otherwise, onBlur closes popper and onClick will never be fired
       */
      onMouseDown={onClick}
      tabIndex={-1}
      sx={{
        px: 2,
        py: 1,
        display: "flex",
        minWidth: "max-content",
        bgcolor: highlighted ? "action.selected" : "transparent",
      }}
    >
      <ListItemIcon sx={{ minWidth: 0, mr: 4, justifyContent: "center" }}>
        <HistoryRounded />
      </ListItemIcon>
      <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2, flex: "1 1 auto" }}>
        <ListItemText primary={formatClientDisplayName(client, language)} slotProps={{ primary: { noWrap: true } }} />
        <ListItemText
          primary={formatClientSmartSearchDate(client.openedAt, t, language)}
          slotProps={{ primary: { noWrap: true, textAlign: "right" } }}
          sx={{ flexShrink: 0 }}
        />
      </Box>
    </ListItemButton>
  );
};
